import * as React from 'react';
const Start = () => (
  <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6013 22.5174L17.0714 15.4779C18.4182 15.2206 21.7756 14.4349 24.6264 13.3505C27.4771 12.2662 25.5464 11.301 24.2246 10.9539L17.0714 8.67416C16.6551 7.13289 15.487 3.26399 14.9197 1.23631C14.3524 -0.79137 13.4746 0.341343 13.1066 1.16116L10.3317 8.67416L1.74523 10.8364C-0.0365043 11.5141 1.04474 12.1226 1.80809 12.3421L10.3317 15.4779L12.0353 22.4737C13.0344 26.1727 14.1623 24.0441 14.6013 22.5174Z" fill="#FFFF33" />
  </svg>
);
export default Start;
